import { useGraphql } from 'utils/hooks/useGraphql';
import { FetchRootAssetFolderQuery } from 'api/queries/creativeLibrary';

export const ROOT_FOLDER_ID = 1;

/**
 * This is temporary until we can get this off project settings
 * https://iterable.slab.com/posts/7-1-21-treating-null-as-folder-id-for-root-folders-8tre2dp6#proposed-options
 */
export const useRootAssetFolderId = (): number => {
  const { data } = useGraphql(FetchRootAssetFolderQuery, {
    variables: {
      folderId: null,
    },
  });

  return data?.assetFolder?.id || ROOT_FOLDER_ID;
};
